import { useLocaleStore, type Locale } from './locale';

const INTL_LOCALE: Record<Locale, string> = { de: 'de-DE', en: 'en-GB' };

/** The Intl locale tag for the current app locale — for passing into non-hook formatting code. */
export function useIntlLocale(): string {
  const locale = useLocaleStore((s) => s.locale);
  return INTL_LOCALE[locale];
}

/** Locale-aware `Intl` formatters, re-created on locale change. */
export function useFmt() {
  const locale = useLocaleStore((s) => s.locale);
  const tag = INTL_LOCALE[locale];
  return {
    number: (n: number, opts?: Intl.NumberFormatOptions) => new Intl.NumberFormat(tag, opts).format(n),
    date: (d: Date | number, opts?: Intl.DateTimeFormatOptions) =>
      new Intl.DateTimeFormat(tag, opts ?? { dateStyle: 'medium' }).format(d),
    dateTime: (d: Date | number, opts?: Intl.DateTimeFormatOptions) =>
      new Intl.DateTimeFormat(tag, opts ?? { dateStyle: 'medium', timeStyle: 'short' }).format(d),
  };
}
